import { Images } from '../../utils';
import React from 'react';
import { SimpleTooltip } from './tooltip';

export const ToolInfo = ({ text, noTool, iconStyle={} }) => {
    return (
        <div>
            {noTool ? (
                <img src={Images.toolInfoIcon} alt={'icon'} />
            ) : (
                <SimpleTooltip title={<div>{text}</div>} placement="top-start">
                    <img src={Images.toolInfoIcon} alt={'icon'} style={{...iconStyle}}  />
                </SimpleTooltip>
            )}
        </div>
    );
};
